import "./course_card.scss";
